import { useLogout } from './useLogout'

export const useResponseStatus = (response: 400 | 401 | 500) => {
  if (response === 401) {
    useLogout()
  }
}
